module.exports = __webpack_public_path__ + "media/images/sprite/ico-facebook@2x-f74de74e3cf7cb91770602a9268e5d96.png";